import * as s from '../user/salesrep.model';
import * as se from '../user/setup.model';
import * as om from '../order/ordermessage.model';
import * as access from '../user/accessright.model';
import * as ot from '../user/ordertype.model';

export class UserModel {
    user_id: number;
    login: string;
    password: string;
    user_name: string;
    email: string;
    phone_number: string;
    country_code: string;
    country_name: string;
    principal_code: string;
    principal_name: string;
    currency: string;
    setting_id: string;
    first_login: number;
    survey_completed_status: number;
    survey_nps_url: string
    contact_info: string;
    contact_message: string;
    pwd_expiry: number;
    pwd_expiry_rmd: number;
    login_date: string;
    pwd_changed_date: string;
    token: string;
    max_num_of_order_attachments: number;
    ordermessage_list: om.OrderMessageModel[] = [];
    salesrep_list: s.SalesrepModel[] = [];
    salesrep_list_original: s.SalesrepModel[] = [];
    setup_list: se.SetupModel[] = [];
    accessright_list: access.AccessRightModel[] = [];
    condition_type_list: string;
    condition_type_tax: string;
    order_type_list: ot.OrderTypeModel[] = [];
    print_ship_remark: string;
    qoute_contact_email_list:string;
    quote_mov_info: string;
    cust_restriction_policy: string;

    oid: string;
    tid: string;
    principal_id: string;
    user_type_id: string;
    otp: string;
    impersonateUser: ImpersonateUser

    constructor() {
        this.impersonateUser = new ImpersonateUser()
    }
}

export class ImpersonateUser {
    user_id: number;
    login: string;
    user_type_id: string;
    transaction_id: string;
}




// WEBPACK FOOTER //
// ./src/models/user/user.model.ts